var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.9994,
    cy: 70.8099,
    r: 70.8099,
    fill: "#53B175"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4209_60844)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.9979,
    cy: 70.8098,
    r: 61.3156,
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.19668
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.7989 55.2744C99.7989 57.1906 99.0744 59.0408 97.7572 60.3624L67.1314 91.1551C65.7483 92.4767 63.9041 93.2696 61.9941 93.2696C60.0841 93.2696 58.24 92.4767 56.9227 91.1551L41.5769 75.7588C40.2596 74.4372 39.5352 72.587 39.5352 70.6707C39.5352 68.7544 40.3255 66.9703 41.6427 65.5826C43.0258 64.2611 44.8041 63.5342 46.7141 63.4681C48.6241 63.4681 50.4024 64.195 51.7855 65.5166L61.9941 75.7588L87.5486 50.1202C88.9317 48.7986 90.71 48.0718 92.62 48.0718C94.53 48.1379 96.3082 48.8647 97.6913 50.2524C99.0086 51.5739 99.7989 53.3581 99.7989 55.2744Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4209_60844",
    x: 6.69063,
    y: 8.29753,
    width: 128.615,
    height: 128.615,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.79502
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.19668
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4209_60844"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4209_60844",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.e58292f3027501bfa92a11887d4d5c01.svg";
export { ForwardRef as ReactComponent };